import { useEffect } from "react"
import { Routers } from "../../../../../../../constant/Routers"
import { backToLogin } from "../../../../../../../utils/backToLogin"
import { UseTravelersBatchImportType } from "../../../../models/batchImport"
import { TravelersBatchImportDataType } from "../../../../models/batchImport/data"
import { useVariables } from "../useVariables"
import { getUserInformation } from "../../../../../../../utils/getUserInformation"

const { SCR920 } = Routers

export const useTravelersBatchImport =
  (): UseTravelersBatchImportType<TravelersBatchImportDataType> => {
    const {
      beforeUpload,
      bulkAdd,
      bulkCheck,
      bulkDeleteData,
      bulkFileAdd,
      columnErrors,
      columns,
      countRecord,
      dataTemps,
      errorList,
      fileNameList,
      form,
      isDisabledSubmit,
      isLoading,
      isLoadingLayout,
      isNotAccessScreen,
      isOpen,
      isOpenUploaded,
      isResetTable,
      isRoleSubAdmin,
      isVisibleBtnCancel,
      isVisibleBtnRegister,
      onCancel,
      onCancelUploaded,
      onChange,
      onOpen,
      onOpenDeleted,
      perItem,
      push,
    } = useVariables()

    const bulkDeleteDataConfirm = () => {
      bulkDeleteData()
      push(SCR920)
    }

    const onOpenDeletedOrGoToHome = () => {
      if (dataTemps.length) {
        onOpenDeleted()
      } else {
        push(SCR920)
      }
    }

    useEffect(() => {
      // ユーザーの画面アクセス許可チェックを処理する。
      if (isNotAccessScreen) {
        // 「SCR973_エラー情報の表示画面」に遷移する。
        const { pathname, state } = backToLogin()
        push({ pathname, state })
      } else {
        bulkCheck()
        if (isRoleSubAdmin) {
          const userInformation = getUserInformation()
          form.setFieldValue("registerRequestUserId", userInformation?.userId)
        }
      }
    }, [])

    return {
      beforeUpload,
      bulkAdd,
      bulkDeleteDataConfirm,
      bulkFileAdd,
      columnErrors,
      columns,
      countRecord,
      dataTemps,
      errorList,
      fileNameList,
      form,
      isDisabledSubmit,
      isLoading,
      isLoadingLayout,
      isOpen,
      isOpenUploaded,
      isResetTable,
      isVisibleBtnCancel,
      isVisibleBtnRegister,
      onCancel,
      onCancelUploaded,
      onChange,
      onOpen,
      onOpenDeletedOrGoToHome,
      perItem,
    }
  }
